const guestRoutes = [
  /^\/login$/,
  /^\/accept-invitation/,
  /^\/recover-password/,
  /^\/reset-password/,
  /^\/social\/clients\/([0-9]+)\/accounts\/reconnect\/(.+)/,
  /^\/social\/clients\/([0-9]+)\/posts\/import\/(.+)/,
];

export default function isGuestRoute(path: string) {
  for (let i = 0; i < guestRoutes.length; i += 1) {
    if (path.match(guestRoutes[i])) {
      return true;
    }
  }
  return false;
}
